<resource-activity [resourceId]="(linkType$ | async)?.id"
                   [resourceType]="resourceType"
                   [workspace]="workspace$ | async">
</resource-activity>
